import { NOTIFICATIONS_RECEIVED, NOTIFICATIONS_REMOVE, NOTIFICATIONS_RESET } from '../types';
const initialState = {
    notificationsList: [],
};

const notifications = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case NOTIFICATIONS_RECEIVED: {
            return {
                ...state,
                notificationsList: [...state.notificationsList, payload],
            };
        }
        case NOTIFICATIONS_RESET: {
            return {
                ...state,
                notificationsList: [],
            };
        }
        case NOTIFICATIONS_REMOVE:
            return {
                ...state,
                notificationsList: state.notificationsList.filter(notification => notification.id !== action.payload),
            };

        default: {
            return state;
        }
    }
};

export default notifications;
